export class LoginModel {
  email: string;
  password: string;
  username: string;
  confirmationcode: string;
  challenge: string;
  challengeParams: object;
  session: string;
}
